// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-apk-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

@media (max-width: 768px) {
  .update-apk-grid {
    grid-template-columns: 1fr;
  }
}

.update-apk-card {
  background: #fff;
  border-radius: var(--radius, 8px);
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.update-apk-card__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}

.update-apk-version-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.update-apk-version-row:last-of-type {
  border-bottom: none;
}

.update-apk-version-label {
  color: #64748b;
  font-size: 0.9rem;
}

.update-apk-version-value {
  font-weight: 600;
  color: #0f766e;
  font-size: 1rem;
}

.update-apk-badge {
  margin-top: 1rem;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.update-apk-badge--force {
  background: #fef3c7;
  color: #92400e;
}

.update-apk-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.update-apk-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: var(--radius, 8px);
  padding: 1.5rem;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
}

.update-apk-dropzone:hover,
.update-apk-dropzone--active {
  border-color: #0d9488;
  background: #f0fdfa;
}

.update-apk-file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.update-apk-dropzone-label {
  display: block;
  cursor: pointer;
  color: #64748b;
  font-size: 0.9rem;
}

.update-apk-dropzone-icon {
  display: block;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.update-apk-filename {
  color: #0f766e;
  font-weight: 500;
}

.update-apk-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.update-apk-field-label {
  font-size: 0.85rem;
  color: #475569;
  font-weight: 500;
}

.update-apk-input {
  padding: 0.6rem 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.95rem;
}

.update-apk-input:focus {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.2);
}

.update-apk-submit {
  padding: 0.65rem 1.25rem;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  align-self: flex-start;
}

.update-apk-submit:hover {
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.update-apk-success {
  margin: 0;
  font-size: 0.9rem;
  color: #059669;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/UpdateApk/UpdateApkPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".update-apk-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n@media (max-width: 768px) {\n  .update-apk-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.update-apk-card {\n  background: #fff;\n  border-radius: var(--radius, 8px);\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.update-apk-card__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.update-apk-version-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.update-apk-version-row:last-of-type {\n  border-bottom: none;\n}\n\n.update-apk-version-label {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.update-apk-version-value {\n  font-weight: 600;\n  color: #0f766e;\n  font-size: 1rem;\n}\n\n.update-apk-badge {\n  margin-top: 1rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.update-apk-badge--force {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.update-apk-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.update-apk-dropzone {\n  border: 2px dashed #cbd5e1;\n  border-radius: var(--radius, 8px);\n  padding: 1.5rem;\n  text-align: center;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.update-apk-dropzone:hover,\n.update-apk-dropzone--active {\n  border-color: #0d9488;\n  background: #f0fdfa;\n}\n\n.update-apk-file-input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.update-apk-dropzone-label {\n  display: block;\n  cursor: pointer;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.update-apk-dropzone-icon {\n  display: block;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.update-apk-filename {\n  color: #0f766e;\n  font-weight: 500;\n}\n\n.update-apk-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.update-apk-field-label {\n  font-size: 0.85rem;\n  color: #475569;\n  font-weight: 500;\n}\n\n.update-apk-input {\n  padding: 0.6rem 0.85rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.update-apk-input:focus {\n  outline: none;\n  border-color: #0d9488;\n  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.2);\n}\n\n.update-apk-submit {\n  padding: 0.65rem 1.25rem;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  align-self: flex-start;\n}\n\n.update-apk-submit:hover {\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.update-apk-success {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #059669;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
